import React, { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import api from "@/lib/api";
import { RiskBadge } from "@/components/shared/Controls";

const DIMENSIONS = [
  "Risco de fornecedor", "Risco de preço", "Risco cambial", "Risco logístico",
  "Risco de devolução", "Risco de concorrência", "Risco de baixa demanda",
  "Risco regulatório", "Risco de capital",
];

export default function RiskPanel() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/opportunities").then(({ data }) => setItems(data.opportunities.filter((o) => o.risk_level))).catch(() => {}); }, []);

  const dist = { BAIXO: 0, "MÉDIO": 0, ALTO: 0 };
  items.forEach((o) => { if (dist[o.risk_level] != null) dist[o.risk_level]++; });

  return (
    <div className="space-y-6 animate-float-up">
      <div className="rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground">
        Nenhuma operação é apresentada como <span className="text-foreground font-medium">sem risco</span>. A IA avalia nove dimensões e classifica em BAIXO, MÉDIO ou ALTO.
      </div>
      <div className="grid grid-cols-3 gap-4">
        {Object.entries(dist).map(([k, v]) => (
          <div key={k} className="rounded-xl border border-border bg-card p-5 text-center">
            <RiskBadge level={k} />
            <p className="font-heading text-3xl font-bold mt-2">{v}</p>
            <p className="text-xs text-muted-foreground">oportunidades</p>
          </div>
        ))}
      </div>

      <div className="grid sm:grid-cols-3 gap-3">
        {DIMENSIONS.map((d) => (
          <div key={d} className="rounded-lg border border-border bg-card p-3 flex items-center gap-2 text-sm">
            <ShieldAlert className="h-4 w-4 text-amber-500 shrink-0" /> {d}
          </div>
        ))}
      </div>

      {items.length > 0 && (
        <div className="rounded-xl border border-border bg-card divide-y divide-border">
          {items.map((o) => (
            <div key={o.opportunity_id} className="p-4 flex items-center justify-between gap-3">
              <div>
                <p className="font-medium">{o.product}</p>
                <p className="text-xs text-muted-foreground">Score {o.opportunity_score} · {o.analysis?.risk_factors?.length || 0} fatores</p>
              </div>
              <RiskBadge level={o.risk_level} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
